export type { ShopConfiguration } from '@gourmetta-bestellsystem/shop-config';
export { getConfig } from '@gourmetta-bestellsystem/shop-config';
